{
  "fr": {
    "fileSharing": {
      "public": {
        "empty": {
          "title": "Aucun fichier",
          "description": "Il n'y a encore aucun fichier dans ce partage."
        }
      }
    }
  }
}
